require('jquery-mask-plugin');

class window.FeedbackForm
  constructor: ->
    self = this

    @initForm()
    @initSubmitForm()
    @initGratitude()

  initForm: ->
#    $('.get-feedback__input-container').click (event) ->
#      event.preventDefault();
#      $(this).find('input, textarea').focus();
#      $(this).addClass('get-feedback__input-container--active');
#
#    $(document).mouseup (e) ->
#      container = $('.get-feedback__input-container--active')
#      containerValueBoolean = container.find($('.get-feedback__input')).val() == ''
#      if container.has(e.target).length == 0 and containerValueBoolean
#        container.removeClass('get-feedback__input-container--active');
#      return

    $('input[name="PHONE_PHONE"]').mask('+7 (999) 999-9999');

    # обработка формы
  initSubmitForm: ->
    $(".js-feedback-form").each ->
#      unless $(this).attr('data-init') == 'true'
#        $(this).attr('data-init', true)
      $(this).submit (event) ->
#        window.initSubmitFormFlag = true
        event.preventDefault()
        self = $(this)
        data = self.serialize()
        $.ajax
          url: $(this).attr('action')
          data: data
          dataType: 'html'
          method: 'post'
          error: (error) ->
            $('.error-text').css('display','none');
            $('.base-input-text').removeClass 'error';
            errors = $.parseJSON(error.responseText)
            $.each errors.ERROR, (key, value) ->
              $('input[name="' + key + '"]').addClass 'error'
              $('input[name="' + key + '"]').parents('.base-input-wrapper').find('.error-text').html(value).css('display','block');
              $('textarea[name="' + key + '"]').parents('.base-input-wrapper').find('.error-text').html(value).css('display','block');


          success: (result) ->
            $('.base-input-text').removeClass 'error';
            $('.error-text').css('display','none');
            $('#gratitude').addClass('gratitude-block--active');

  initGratitude: ->
    $('.gratitude__close-button').click (event) ->
      $('.gratitude-block').removeClass('gratitude-block--active');

    $('.gratitude-block__wrapper').click (event) ->
      if $(event.target).closest('.gratitude-block__container').length
        return
      $('.gratitude-block').removeClass('gratitude-block--active');


// WEBPACK FOOTER //
// ./assets/javascripts/app/feedback_form.coffee